<template>
  <div class="my-4">
    <h3
      v-if="title"
      class="font-medium text-xl lg:text-2xl text-gray-700 mb-2"
    >
      {{ title }}
    </h3>
    <div class="flex gap-3 items-center">
      <button
        class="bg-transparent border-none cursor-pointer p-2 rounded-lg transition-all duration-200 flex items-center justify-center hover:bg-gray-100 hover:-translate-y-0.5 focus:outline-2 focus:outline-blue-500 focus:outline-offset-2 active:translate-y-0"
        aria-label="Share on Facebook"
        title="Share on Facebook"
        @click="shareOnFacebook"
      >
        <SvgIcon
          name="facebook"
          aria-label="Facebook"
        />
      </button>

      <button
        class="bg-transparent border-none cursor-pointer p-2 rounded-lg transition-all duration-200 flex items-center justify-center hover:bg-gray-100 hover:-translate-y-0.5 focus:outline-2 focus:outline-blue-500 focus:outline-offset-2 active:translate-y-0"
        aria-label="Share on LinkedIn"
        title="Share on LinkedIn"
        @click="shareOnLinkedIn"
      >
        <SvgIcon
          name="linkedin"
          aria-label="LinkedIn"
        />
      </button>

      <button
        class="bg-transparent border-none cursor-pointer p-2 rounded-lg transition-all duration-200 flex items-center justify-center hover:bg-gray-100 hover:-translate-y-0.5 focus:outline-2 focus:outline-blue-500 focus:outline-offset-2 active:translate-y-0"
        aria-label="Share on X (Twitter)"
        title="Share on X (Twitter)"
        @click="shareOnX"
      >
        <SvgIcon
          name="x"
          aria-label="X (Twitter)"
        />
      </button>

      <button
        class="bg-transparent border-none cursor-pointer p-2 rounded-lg transition-all duration-200 flex items-center justify-center hover:bg-gray-100 hover:-translate-y-0.5 focus:outline-2 focus:outline-blue-500 focus:outline-offset-2 active:translate-y-0"
        aria-label="Share via Email"
        title="Share via Email"
        @click="shareViaEmail"
      >
        <svg
          width="2em"
          height="2em"
          viewBox="0 0 24 24"
          fill="#cccccc"
          xmlns="http://www.w3.org/2000/svg"
          role="img"
        >
          <title>Email</title>
          <path
            d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.89 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
            fill="#cccccc"
          />
        </svg>
      </button>

      <button
        class="bg-transparent border-none cursor-pointer p-2 rounded-lg transition-all duration-200 flex items-center justify-center hover:bg-gray-100 hover:-translate-y-0.5 focus:outline-2 focus:outline-blue-500 focus:outline-offset-2 active:translate-y-0"
        aria-label="Copy URL"
        :title="urlCopied ? 'URL Copied!' : 'Copy URL'"
        @click="copyUrl"
      >
        <SvgIcon
          name="copy"
          aria-label="Copy URL"
        />
      </button>
    </div>
  </div>
</template>

<script>
import { useRoute } from 'vue-router'
import SvgIcon from './SvgIcon.vue'
import { useRuntimeConfig } from '#app'

export default {
  name: 'ShareOnSocialMedia',
  components: {
    SvgIcon
  },
  props: {
    text: {
      type: String,
      default: 'Check this out!'
    },
    title: {
      type: String,
      default: 'Share this:'
    }
  },
  data() {
    return {
      urlCopied: false
    }
  },
  computed: {
    currentUrl() {
      if (import.meta.client) {
        return window.location.href
      }
      // For SSR, construct URL from route
      const route = useRoute()
      const config = useRuntimeConfig()
      return `${config.public.baseUrl || 'https://employers.io'}${route.fullPath}`
    }
  },
  methods: {
    shareOnFacebook() {
      const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.currentUrl)}&quote=${encodeURIComponent(this.text)}`
      this.openShareWindow(shareUrl)
    },

    shareOnLinkedIn() {
      const shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(this.currentUrl)}&text=${encodeURIComponent(this.text)}`
      this.openShareWindow(shareUrl)
    },

    shareOnX() {
      const shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(this.currentUrl)}&text=${encodeURIComponent(this.text)}`
      this.openShareWindow(shareUrl)
    },

    shareViaEmail() {
      const subject = encodeURIComponent(this.text)
      const body = encodeURIComponent(`${this.text}\n\n${this.currentUrl}`)
      const mailtoUrl = `mailto:?subject=${subject}&body=${body}`
      window.location.href = mailtoUrl
    },

    async copyUrl() {
      try {
        await navigator.clipboard.writeText(this.currentUrl)
        this.urlCopied = true
        setTimeout(() => {
          this.urlCopied = false
        }, 2000)
      } catch (err) {
        // Fallback for older browsers
        const textArea = document.createElement('textarea')
        textArea.value = this.currentUrl
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand('copy')
        document.body.removeChild(textArea)
        this.urlCopied = true
        setTimeout(() => {
          this.urlCopied = false
        }, 2000)
      }
    },

    openShareWindow(url) {
      const width = 600
      const height = 400
      const left = (window.innerWidth - width) / 2
      const top = (window.innerHeight - height) / 2

      window.open(
        url,
        'shareWindow',
        `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
      )
    }
  }
}
</script>

